import {
  Route as ReactDomRoute,
  RouteProps as ReactDOMRouteProps,
  Redirect
} from 'react-router-dom';

import { useAuth } from '../hooks/auth';
import Loading from '../components/Loading';

interface RouteProps extends ReactDOMRouteProps  {
  isPrivate?: boolean;
	component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
	component: Component,
  ...rest
}) => {
	const { user, userPintor10, isLoadingUserStorageData } = useAuth();

	const url_aux = JSON.stringify(window.location.href);

	if (isLoadingUserStorageData)
		return <Loading />

	return (
		<ReactDomRoute
			{...rest}
			render={({ location }) => {
				return url_aux.includes('pintor10') 
				? isPrivate === !!userPintor10
					? <Component />
					: <Redirect
						to={{
							pathname: isPrivate ? '/' : '/accountdelete',
							state: { from: location },
						}}
					/>
				: location.pathname === '/'
					? <Redirect
						to={{
							pathname: '/login',
							state: { from: location },
						}}
					/>
					: isPrivate === !!user
						? <Component />
						: <Redirect
							to={{
								pathname: isPrivate ? '/login' : '/dashboard',
								state: { from: location },
							}}
						/>
			}
			}
		/>
	);
};

export default Route;

/*
const { user, userPintor10, isLoadingUserStorageData } = useAuth();

	if (isLoadingUserStorageData)
		return <Loading />

	const isPinto10 = useMemo(() => window.location.href.includes('pinto10'), []);

	const isAuthenticated = isPinto10 ? !!userPintor10 : !!user;

	const redirectPath = useMemo(() => {
		if (isPinto10) 
			return isPrivate ? '/' : '/accountdelete';

		if(rest.path === '/')
			return '/login'

		return isPrivate ? '/login' : '/dashboard';

	}, []);

	console.log('redirectPath ==> ', redirectPath);

	return (
		<ReactDomRoute
			{...rest}
			render={({ location }) =>
				isAuthenticated === isPrivate ? (
					<Component />
				)	: (
					<Redirect
						to={{ 
							pathname: redirectPath,
							state: { from: location }
						}}
					/>
				)
			}
		/>
	)
*/
